import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
    type: 'demographic',
    list: [],
    isLoading: false,
    collection: {}
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
